import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const tabs = [
  {
    label: "Submitted candidates",
    route: "submitted-candidates",
  },
  {
    label: "Job details",
    route: "job-details",
  },
  {
    label: "Recruitment agents",
    route: "recruitment-agents",
  },
  {
    label: "Hiring team",
    route: "hiring-team",
  },
];

const JobRequiremenLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    tabs?.forEach((item, index) => {
      if (pathname?.includes(item?.route)) setActiveTab(index);
    });
  }, [pathname]);
  
  return (
    <div className="bg-white rounded-md flex flex-col flex-1 p-5">
      <button
        onClick={() => navigate("/requirements")}
        className="flex items-center self-start gap-1"
      >
        <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
        <label className="text-xs font-medium text-charcoal cursor-pointer">
          Back to listing
        </label>
      </button>

      {/* MainBody */}
      <div className="flex flex-col flex-1 px-5 pt-5 min-h-0">
        {/* Tabs Container */}
        <div className="flex items-center gap-8 border-b pb-2">
          {tabs?.map((item, index) => {
            const isSelected = activeTab === index;
            return (
              <button
                onClick={() => {
                  setActiveTab(index);
                  navigate(item?.route);
                }}
                key={item?.route}
                style={{
                  borderBottom: isSelected
                    ? "1.5px solid #FF9800"
                    : "1.5px solid transparent",
                }}
                className={`px-1 flex justify-center items-center h-full cursor-pointer pb-0.5 ${
                  isSelected ? "text-charcoal" : "text-light-grey"
                } font-medium text-sm`}
              >
                {item?.label}&nbsp;
                <span
                  className={`${
                    isSelected ? "text-blue-500" : "text-light-grey"
                  } text-xs`}
                ></span>
              </button>
            );
          })}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default JobRequiremenLayout;
